import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.082 12.98a1.998 1.998 0 0 0-1.55.66L1.022 25 11.53 36.36c.48.535 1.215.773 1.922.617a2.003 2.003 0 0 0 1.016-3.336L8.324 27H47a1.988 1.988 0 0 0 1.754-.992 1.982 1.982 0 0 0 0-2.016A1.988 1.988 0 0 0 47 23H8.324l6.145-6.64a2.003 2.003 0 0 0-1.387-3.38Z" }, null, -1)
  ])))
}
export default { render: render }